import Vue from 'vue';
import Vuex from 'vuex';

import wahrhouseModule from './modules/warhouses.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state() {
    return {
      open: false,
      currentScrollY: 0,
      loading: false,
      authenticatedUser: null,
    };
  },
  mutations: {
    setAuthenticatedUser(state, authUser) {
      state.authenticatedUser = authUser;
    },
    actionSidebar(state) {
      state.open = !state.open;
    },
    actionloadingpage: function(state, payload) {
      state.loading = payload.loading;
    },
    setCurrentScrollY(s, { y }) {
      s.currentScrollY = y;
    },
  },
  actions: {
    actionSidebar(context) {
      context.commit('actionSidebar');
    },
    actionloadingpage(context, payload) {
      context.commit('actionloadingpage', payload);
    },
    setCurrentScrollY({ commit }, y) {
      commit('setCurrentScrollY', { y });
    },
  },
  getters: {
    accountIsComplete(state) {
      if (!state.authenticatedUser) return false;
      let canAccess = true;
      const { rib, phone, company, PostalCode, type } = state.authenticatedUser;
      if (type === 'Seller') {
        if (!rib || !phone || !company || !PostalCode) {
          canAccess = false;
        }
      }
      return canAccess;
    },
    ShowSidebar(state) {
      return state.open;
    },
    loadingpage(state) {
      return state.loading;
    },
    resize() {
      if (window.innerWidth < 960) return true;
      else return false;
    },
    currentScrollY: s => s.currentScrollY,
  },
  modules: {
    wharhouse: wahrhouseModule,
  },
});
